import React, { useState, createContext } from 'react';

export const SpacebarContext = createContext();

export const SpacebarProvider = ({ children }) => {
  const [value, setValue] = useState(false);
  return <SpacebarContext.Provider value={[value, setValue]}>{children}</SpacebarContext.Provider>;
};
